// import Text from "components/Common/Text";
import PropTypes from "prop-types";
import Text from "components/Common/Text";
import "./styles.css";
// eslint-disable-next-line import/no-cycle
import { VenmoButton } from ".";

export default function Tip({ totalStake }) {
  const tipValue = Math.ceil((totalStake / 100) * 1);
  return (
    <div>
      <Text
        as="H1"
        bold
        ta="center"
        style={{ color: "black", letterSpacing: -1.8 }}
        className="tee-time-player-payout--user-name"
      >
        Match Total Pot is{" "}
        {totalStake.toLocaleString("en-Us", {
          style: "currency",
          currency: "USD",
        })}
      </Text>
      <Text as="P1" bold ta="center" style={{ color: "black", padding: 10 }}>
        If you liked the match, please consider tipping 1% for our effort
      </Text>
      <div style={{ justifyContent: "center", display: "flex" }}>
        <VenmoButton venmoAccount="mike-stashak" amount={tipValue} />
      </div>
    </div>
  );
}

Tip.propTypes = {
  totalStake: PropTypes.number.isRequired,
};
